module.exports = __webpack_public_path__ + "public/assets/img/error.700bd717.svg";